import { Route } from 'react-router';
import ProtectedRoutes from '../components/ProtectedRoutes';
import {
  GameInfoPage,
  GameLaunchPage as _GameLaunchPage,
  ProviderGamesPage,
  RedirectPage,
  PlayWithCoinsPage,
} from '@bonanza-social/games/pages';
import Config from '@bonanza-social/toolkit/config';
import { withMkodoCheck } from '@bonanza-social/mkodo';

const GameLaunchPage = Config.MKODO_ENABLED
  ? withMkodoCheck(_GameLaunchPage)
  : _GameLaunchPage;

export const renderGamesRoutes = () => (
  <>
    <Route element={<ProtectedRoutes />}>
      <Route
        path="/games/launch/:id/:currencyCode?"
        element={<GameLaunchPage />}
      />
      <Route
        path="/game-launch/:id/:currencyCode?"
        element={
          <RedirectPage
            getPath={(params) =>
              `/games/launch/${params.id}${params.currencyCode ? `/${params.currencyCode}` : ''}`
            }
          />
        }
      />
      <Route path="/games/top-slot-providers" element={<ProviderGamesPage />} />
    </Route>
    <Route path="/play-with-coins" element={<PlayWithCoinsPage />} />
    <Route path="/games/:name" element={<GameInfoPage />} />
  </>
);
